import QuoteLinesPanel from '../parts/QuoteLinesPanel';
import { useProjectData } from '../ProjectDataContext';

function OfferteregelsPanel() {
  const {
    quoteLines,
    quoteLinesLoading,
    quoteLinesError,
  } = useProjectData();

  return (
    <>
        <QuoteLinesPanel data={quoteLines} loading={quoteLinesLoading} error={quoteLinesError} />
    </>
  );
}

export default OfferteregelsPanel;
